<mat-card class="large-card">
    <mat-form-field fluid appearance="outline" class="example-full-width">
        <mat-label>Find Mapping</mat-label>
        <input
            matInput
            [(ngModel)]="mappingSearchTerm"
            class="search-field"
            #mappingSearchBox
            (ngModelChange)="filterMappings()"
            [ngModelOptions]="{ standalone: true }"
        />
        <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
    <div class="settingsBody">
        <div class="settingsDescription">{{ mappingDescription }}</div>
        <br />
        <kendo-grid
            [data]="tableData"
            [height]="695"
            [pageSize]="pageSize"
            [skip]="skip"
            [pageable]="true"
            [sort]="mappingSort"
            [sortable]="{
                mode: 'single',
                allowUnsort: false
            }"
            (sortChange)="sortChange($event)"
            [scrollable]="true"
            [loading]="loading"
            (pageChange)="pageChange($event)"
            class="lg-kendo-grid"
        >
            <kendo-grid-column field="clientTag" title="CLIENT VALUE"></kendo-grid-column>
            <kendo-grid-column field="lookupValue" [title]="mappingTitle">
                <ng-template kendoGridCellTemplate let-item>
                    <select
                        [(ngModel)]="item.typeKey"
                        class="select-light-border-38"
                        (ngModelChange)="mappingChangeHandler(item)"
                    >
                        <option *ngFor="let type of mappingTypes" [value]="type.typeKey">
                            {{ type.typeValue }}
                        </option>
                    </select>
                </ng-template>
            </kendo-grid-column>
            
            <ng-template kendoPagerTemplate>
                <kendo-pager-prev-buttons class="text-color-black"></kendo-pager-prev-buttons>
                <kendo-pager-input class="text-color-black"></kendo-pager-input>
                <kendo-pager-info class="text-color-black"></kendo-pager-info>
                <kendo-pager-next-buttons class="text-color-black"></kendo-pager-next-buttons>
                <kendo-pager-page-sizes
                    class="text-color-black"
                    [pageSizes]="[10, 25, 50, 100]"
                ></kendo-pager-page-sizes>
            </ng-template>
        </kendo-grid>
    </div>
    <div style="text-align: right;">
        <button
            mat-raised-button
            class="submitButton"
            [disabled]="saveBtnDisabled"
            (click)="submitChanges()"
        >
            SAVE CHANGES
        </button>
    </div>
</mat-card>